var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M2 19H1v1h1v-1zM22 5h1V4h-1v1zM10 4a1 1 0 000 2V4zM5 6a1 1 0 000-2v2zM2 20h18v-2H2v2zM1 7v10h2V7H1zm0 10v2h2v-2H1zm22 0V5h-2v12h2zM22 4H10v2h12V4zM5 4H4v2h1V4zm15 16a3 3 0 003-3h-2a1 1 0 01-1 1v2zM3 7a1 1 0 011-1V4a3 3 0 00-3 3h2z",
          fill: "#2C3143",
        },
      }),
      _c("circle", {
        attrs: {
          cx: "17",
          cy: "10",
          r: "2",
          stroke: "#2C3143",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17 19l-4-6-2 3-3-5-5 8",
          stroke: "#2C3143",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }